import Routing from "./routing/Routing";
import './App.css'

function App() {
  return (
    <>
      <Routing />
    </>
  );
}

export default App;
